import Vue from "vue";

export const stripTags = function (originalString) {
  // Converting originalString into string, because if given argument was number there was an error thrown.
  // originalString.replace is not a function
  return originalString ? (originalString+"").replace(/(<([^>]+)>)/gi, "") : originalString;
}

Vue.filter("stripTags", stripTags);
